<template>
  <v-container class="text-center pr-0 pl-0" fluid>
    
    <card-treino v-bind:item="item" v-for="item in items" :key="item.id" :showAluno="showAluno"/>

    <transparent-message-box :myMessage="myMessage" v-if="(!items || items.length < 1) && finishedLoad"/>

  </v-container>
</template>

<script>
import CardTreino from '../../components/CardTreino.vue';
import TransparentMessageBox from '../../components/TransparentMessageBox.vue';
import {myMixin} from '../../mixin';

//import axios from 'axios';
import HOST from '../../ws'
//import SnackBar from "../snackbar";


export default {

  components : {
    CardTreino,
    TransparentMessageBox,
  },

  mixins : [
    myMixin
  ],

  props: {
    source: String
  },

  beforeMount () {

    var tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);

    this.reloadItemList();
    console.log('de ' + this.formataData(new Date()) + ' a ' + this.formataData(tomorrow));
  },

  data: () => ({
    
    items : null,
    showAluno : true,
    finishedLoad : false,

    myMessage : 'Não há treinos dos seus alunos para o dia.',

  }),

  methods : {

    reloadItemList(){

      var tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);

      this.$store.commit("setLoader", true);
      let requestData = {
        inicio : this.formataData(new Date()),
        fim : this.formataData(tomorrow),
      }
      this.axios({
        method: 'post',
        url : HOST.HOST + '/treino/todosostreinosdodia', 
        headers: {
            'Content-Type' : 'application/json',
            Authorization: `Bearer ${this.$store.state.currentToken}`},
            data : JSON.stringify(requestData)
      }).then((response) => {

        console.log('consulta dos treinos: ' + response.status); 
        this.items = response.data;
        this.$store.commit("setLoader", false);
        this.finishedLoad = true;
        //console.log(JSON.stringify(this.items));
      })
      .catch(error => {
        console.log(error.message);
        this.$store.commit("setLoader", false);
        this.$store.commit("logout");
        this.$router.push("/");
       });
    }
  }
};
</script>

<style>



</style>